/*
  •	Copyright (c) 2024 Pegasystems Inc.
  •	All rights reserved.
*/
import TargetMap from '../../actions/targetmap';
import { ACTION_CREATE_EXTERNAL_OBJECT } from '../../store/state/actions';
import APP_CONSTANTS from '../../constants';
import type { Action } from '../../store/state/state-manager';

export const getContainerName = (createWorkActionPayload: Action['payload']) => {
  const { containerName, isInCreateStage } = createWorkActionPayload;
  if (isInCreateStage) {
    return APP_CONSTANTS.MODAL;
  }
  return containerName || TargetMap.getTargetViewContainerName(ACTION_CREATE_EXTERNAL_OBJECT);
};

export default { getContainerName };
